import { PartialDesignTokens } from './design-tokens.interface';

// ── Assets ──────────────────────────────────────────────────

export interface TenantAssets {
  logoUrl: string | null;
  logoSmallUrl: string | null;
  faviconUrl: string | null;
}

export const DEFAULT_TENANT_ASSETS: TenantAssets = {
  logoUrl: 'assets/img/logo_polipay.svg',
  logoSmallUrl: 'assets/img/logo_small.svg',
  faviconUrl: null,
};

// ── Wording (key brand terms, NOT full i18n) ────────────────

export interface TenantWording {
  appName: string;
  appNameLower: string;
  companyLabel: string;
  [key: string]: string;
}

// ── Feature flags ───────────────────────────────────────────

export interface TenantFeatures {
  showReports: boolean;
  showExport: boolean;
  transactions: boolean;
  cards: boolean;
  ecommerce: boolean;
  referencePayments: boolean;
  tpv: boolean;
  administration: boolean;
  dispersions: boolean;
  enterprise: boolean;
  [key: string]: boolean;
}

// ── Full API response ───────────────────────────────────────

/**
 * Response from the tenant theme API endpoint.
 * GET /api/v1/tenants/{tenantId}/theme
 */
export interface TenantThemeApiResponse {
  tenantId: string;
  tokens: PartialDesignTokens | null;
  assets: TenantAssets | null;
  wording: TenantWording | null;
  features: TenantFeatures | null;
}

// ── Defaults ────────────────────────────────────────────────

export const DEFAULT_TENANT_WORDING: TenantWording = {
  appName: 'Polipay',
  appNameLower: 'polipay',
  // Entidad regulada (SOFOM E.N.R.) que opera el producto financiero. NO es la
  // marca del producto: aparece exclusivamente en cláusulas legales del
  // consentimiento Buró/SAT y custodia. La marca de cara al usuario es `appName`.
  legalEntity: 'SOLVENDOM',
  companyLabel: 'Empresa',
  contactPhone: '+52 55 4770 4729',
  contactEmail: 'contacto@polipay.mx',
  supportUrl: 'https://soporte.polipay.io',
};

export const DEFAULT_TENANT_FEATURES: TenantFeatures = {
  showReports: true,
  showExport: true,
  transactions: true,
  cards: true,
  ecommerce: true,
  referencePayments: true,
  tpv: true,
  administration: true,
  dispersions: true,
  enterprise: true,
};

// ── Deprecated (backward compat) ────────────────────────────

/**
 * @deprecated Use TenantThemeApiResponse instead.
 */
export interface TenantThemeResponse {
  theme: PartialDesignTokens | null;
  logo_url: string | null;
}
